import { createSelector } from 'reselect';

const userSettings = (state) => state?.user?.user?.settings;

export const directMarketingSelector = createSelector(
  [userSettings],
  (settings) => settings?.directMarketing || 0,
);
